module.exports = __webpack_public_path__ + "img/home-btn.903effe7.png";